module.exports = __webpack_public_path__ + "img/qrcode.bb10ef78.jpg";